import { type ObjectValuesUnionType } from '../../utils/typing';

// Action types
export const NetworkActionTypes = Object.freeze({
  CONNECT: 'socket/connect',
  RECONNECT: 'socket/reconnect',
  CONNECTED: 'socket/connected',
  DISCONNECTED: 'socket/disconnected',
  CLOSE: 'socket/close',
  SEND: 'socket/send',
  RECV: 'socket/recv',
});

export type NetworkActionType = ObjectValuesUnionType<typeof NetworkActionTypes>;
